import { render, staticRenderFns } from "./StepTen.vue?vue&type=template&id=75ef167c&"
import script from "./StepTen.vue?vue&type=script&lang=js&"
export * from "./StepTen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports